module.exports = __webpack_public_path__ + "img/4064003130.b7e8ed3d.jpg";